const variables = {
  variant: 'secondary',
};

export default variables;
